// Link between the saved profile and the active culture: detects the device time zone in automatic mode
// (the profile keeps a concrete time zone, used by the server) and applies every preference change.
import { DEFAULT_CULTURE } from '@gruvetto/core';
import { state, update, onChange } from './store.js';
import { applyCulture, deviceEnv } from '../i18n/index.js';

function sync() {
  const c = { ...DEFAULT_CULTURE, ...state.profile.culture };
  const detected = deviceEnv().timeZone;
  // The update re-runs sync() through onChange, which then applies the culture.
  if (c.autoTimeZone && c.timeZone !== detected) { update(s => { s.profile.culture = { ...c, timeZone: detected }; }); return; }
  applyCulture(c);
}

/** To call before the first render. */
export function startCulture() {
  sync();
  onChange(sync);
}
